import { getManagementApiBaseUrl } from '../../utils/management-api';

export class DomainMaxLossEndpoint {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${getManagementApiBaseUrl()}/domain-max-loss`;
	}

	status() {
		return `${this.baseUrl}/status`;
	}

	unPauseDomains() {
		return `${this.baseUrl}/unPauseDomains`;
	}
}
